import type { CSSProperties } from 'react';
import { Toaster } from '../components/sonner';

export { toast } from 'sonner';

// The game's snackbars. They sit just under the screen headers, so a back button is never covered and
// nothing on the page moves when one shows; a swipe or a few seconds clears them.
export function GameToaster() {
  return (
    <Toaster
      theme="light"
      position="top-center"
      offset={{ top: 'calc(env(safe-area-inset-top) + 72px)' }}
      mobileOffset={{ top: 'calc(env(safe-area-inset-top) + 62px)', left: '12px', right: '12px' }}
      visibleToasts={3}
      duration={3500}
      gap={8}
      swipeDirections={['top', 'left', 'right']}
      toastOptions={{ className: 'game-toast' }}
      style={
        {
          '--normal-bg': 'var(--foreground)',
          '--normal-text': 'var(--card)',
          '--normal-border': 'var(--foreground)',
          '--border-radius': '16px',
        } as CSSProperties
      }
    />
  );
}
